import { EChartsOption } from "echarts";
import { generateNumbers } from "@/utils/math";
export type PlayStatus = "play" | "pause" | "stop";
export const LENGTH = 15; // S
export const decreasingSequence = generateNumbers(LENGTH);

export const getDefaultSeriesData = () => {
  const res = {
    UIRx_VehSpd: [],
    UIRx_FLWhlSpd_BCh1: [],
    UIRx_FRWhlSpd_BCh1: [],
    UIRx_RLWhlSpd_BCh1: [],
    UIRx_RRWhlSpd_BCh1: [],
    UIRx_MotTq_FA: [],
    UIRx_MotTq_RA: [],
    UIRx_WhlBrkTqAct_FL_BCh1: [],
    UIRx_WhlBrkTqAct_FR_BCh1: [],
    UIRx_WhlBrkTqAct_RL_BCh1: [],
    UIRx_WhlBrkTqAct_RR_BCh1: [],
  } as DomianControl.MAABSSeriesData;
  return res;
};

export function parseMotTq(data: number) {
  // Mot_FL = abs( min(UIRx_MotTq_FA, 0 ) / 2 )*12；
  const res = Math.abs(Math.min(data, 0) / 2) * 12;
  // 小于10，都当0
  if (res < 10) {
    return 0;
  }
  return res;
}
export function parseMotTqChart(data: number) {
  // abs( min(UIRx_MotTq_RA, 0 ) )
  const res = Math.abs(Math.min(data, 0)) * 12;
  return res;
}

export const optionseries1 = () => [
  {
    id: "UIRx_VehSpd",
    name: "车速",
    color: "#c10301",
  },
  {
    id: "UIRx_WhlBrkTqAct_FL_BCh1",
    name: "左前轮轮速",
    color: "#2E8B57",
  },
  {
    id: "UIRx_WhlBrkTqAct_FR_BCh1",
    name: "右前轮轮速",
    color: "#ffc101",
  },
  {
    id: "UIRx_WhlBrkTqAct_RL_BCh1",
    name: "左后轮轮速",
    color: "#0372bf",
  },
  {
    id: "UIRx_WhlBrkTqAct_RR_BCh1",
    name: "右后轮轮速",
    color: "#9B30FF",
  },
];

export const optionseries2 = () => [
  {
    id: "UIRx_FLWhlSpd_BCh1",
    name: "左前轮摩擦力矩",
    color: "#0372bf",
  },
  {
    id: "UIRx_FRWhlSpd_BCh1",
    name: "右前轮摩擦力矩",
    color: "#2E8B57",
  },

  {
    id: "UIRx_MotTq_FA",
    name: "前轴电制动力矩",
    color: "#ffc101",
  },
];
export const optionseries3 = () => [
  {
    id: "UIRx_RLWhlSpd_BCh1",
    name: "左后轮摩擦力矩",
    color: "#0372bf",
  },
  {
    id: "UIRx_RRWhlSpd_BCh1",
    name: "右后轮摩擦力矩",
    color: "#2E8B57",
  },

  {
    id: "UIRx_MotTq_RA",
    name: "后轴电制动力矩",
    color: "#ffc101",
  },
];
// export const optionseries1 = () => [
//   {
//     id: "big",
//     name: "大间隙",
//     color: "#2E8B57",
//   },
//   {
//     id: "middle",
//     name: "中间隙",
//     color: "#ffc101",
//   },
//   {
//     id: "small",
//     name: "小间隙",
//     color: "#c10301",
//   },
// ];
// export const optionseries2 = () => [
//   {
//     id: "UIRx_ACUYawRate",
//     name: "实际横摆特性",
//     color: "#0372bf",
//   },
//   {
//     id: "UIRx_OrgYawRate",
//     name: "原始横摆特性",
//     color: "#9B30FF",
//   },
// ];
// export const optionseries3 = () => [
//   {
//     id: "UIRx_AxleStAng_RA",
//     name: "后轮角度",
//     color: "#2E8B57",
//   },
// ];

export const getTooltip = () => {
  return {
    show: true,
    // formatter: `{c}`,
    formatter: function (params: any[]) {
      console.log("[BOWEN_LOG] 🚀 ~~ getTooltip ~~ params:", params);

      const axisValue = params[0]?.axisValue || "";
      let tooltipHtml = `<div>${axisValue}</div>`;
      const uniqueParams = new Map<string, any>();

      params.forEach((param) => {
        if (param.value === undefined) return;

        // 生成一个唯一的键，结合 axisValue 和 data
        const key = `${param.axisValue}-${JSON.stringify(param.value)}`;

        // 如果已经存在相同的键，则跳过
        if (!uniqueParams.has(key)) {
          uniqueParams.set(key, param);
        }
      });

      uniqueParams.forEach((param) => {
        if (param.seriesType === "line") {
          tooltipHtml += `<div style="display: flex; align-items: center;">
                        <span style="display: inline-block; margin-right: 5px; border-radius: 50%; width: 10px; height: 10px; background-color: ${param.color};"></span>
                        <span> ${param.seriesName}</span>: <span> ${param.value}</span>
                      </div>`;
        }
      });

      return tooltipHtml;
    },
  };
};

export const getGrid = () => ({
  top: 30,
  left: 50,
  right: 50,
  bottom: 55,
});
export const getTitle = () =>
  ({
    top: 0,
    left: 5,
    textStyle: {
      color: "#032f2b",
      fontSize: 12,
    },
  } as EChartsOption["title"]);

export const getXaxis = () => {
  const lineColor = "rgba(199, 237, 250,0.2)";

  return {
    name: "踏板开度(%)",
    type: "value",
    max: 100,
    min: 0,
    nameTextStyle: {
      color: "#fff",
    },
    interval: 25,
    // nameGap: -30,
    // minorTick: {
    //   show: true,
    // },
    // minorSplitLine: {
    //   show: true,
    //   lineStyle: {
    //     color: lineColor,
    //   },
    // },
    axisPointer: {
      snap: true,
      lineStyle: {
        color: "#8e96a1",
        width: 2,
      },
      label: {
        show: false,
        // formatter: function (params) {
        //   return echarts.format.formatTime('yyyy-MM-dd', params.value);
        // },
        backgroundColor: "#3fafa5",
      },
      handle: {
        show: true,
        color: "#3fafa5",
        size: 30,
        margin: 10,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowBlur: 0,
      },
    },
    splitLine: {
      show: true,
      // interval:25,
      // interval: (index: number, value: string) => {
      //   return (
      //     (Number(value) % 1 === 0 || Number(value) === 1) &&
      //     Number(value) !== 15
      //   );
      // },
      lineStyle: {
        color: lineColor,
      },
    },
    axisLabel: {
      show: true, // 隐藏 x 轴标签
      // interval:25,
      // interval: interval,
      // formatter: (number: string) => {
      //   console.log("[BOWEN_LOG] 🚀 ~~ getChartsDefaultOptions ~~ number:", number);
      //   return Number(number) % 5 === 0 || Number(number) === 1 ? number : "";
      // },
    },
    // axisTick: {
    //   interval,
    // },
    axisLine: {
      onZero: false,
      lineStyle: {
        color: lineColor,
      },
    },
  };
};
const dataZoomOption: any = {
  // rangeMode: "percent",
  // backgroundColor: "#8e96a1",
  fillerColor: "#8e96a1",
  borderRadius: 5,
  moveHandleSize: 10,
  moveHandleStyle: {
    color: "#8e96a1",
  },
  brushStyle: {
    color: "#5aac5d",
    opacity: 0.7,
    borderWidth: 2,
    borderColor: "#5aac5d",
  },
  handleIcon:
    "path://M12 2C17.52 2 22 6.48 22 12S17.52 22 12 22 2 17.52 2 12 6.48 2 12 2zm0 20C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10-4.48 10-10 10z", // jshint ignore:line
  handleSize: 35,
  handleStyle: {
    color: "rgba(0,0,0,1)",
    borderColor: "#8e96a1",
    borderWidth: 0,
    backgroundColor: "#8e96a1",
    opacity: 0.7,
  },
  backgroundColor: "rgba(0,0,0,0.0)",
};

export const getDataZoom2 = () => {
  const dataZoom = [
    {
      id: "dataZoomX",
      type: "slider",
      show: false,
      xAxisIndex: [0],
      height: 20,
      filterMode: "none",
      // right: 20,
      ...dataZoomOption,
      bottom: 10,
      moveHandleSize: 0,
    },
    {
      id: "dataZoomY",
      type: "slider",
      yAxisIndex: [0],
      // height: 10,
      filterMode: "none",
      // right: 20,
      ...dataZoomOption,
      // handleSize: 40,
      moveHandleSize: 10,
      right: 20,
      width: 20,
      top: 60,
      bottom: 40,
      startValue: 0,
      endValue: 1500,
    },
  ];
  return dataZoom;
};

export const getDataZoom1 = () => {
  const dataZoom = [
    {
      id: "dataZoomX",
      type: "slider",
      xAxisIndex: [0],
      height: 20,
      filterMode: "none",
      // right: 20,
      ...dataZoomOption,
      bottom: 10,
      moveHandleSize: 0,
    },
    {
      id: "dataZoomY",
      type: "slider",
      yAxisIndex: [0],
      // height: 10,
      filterMode: "none",
      // right: 20,
      ...dataZoomOption,
      // handleSize: 40,
      moveHandleSize: 10,
      right: 20,
      width: 20,
      top: 60,
      bottom: 40,
      startValue: 0,
      endValue: 50,
    },
  ];
  return dataZoom;
};
